enum MeansType {
  NONE = 'NONE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SECURE_LINK = 'SECURE_LINK',
  IN_PERSON = 'IN_PERSON',
}

export default MeansType;
